import { render, staticRenderFns } from "./chatGroupList.vue?vue&type=template&id=5458ab05&scoped=true"
import script from "./chatGroupList.vue?vue&type=script&lang=js"
export * from "./chatGroupList.vue?vue&type=script&lang=js"
import style0 from "./chatGroupList.vue?vue&type=style&index=0&id=5458ab05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5458ab05",
  null
  
)

export default component.exports